import { render } from "./home-button.vue?vue&type=template&id=4a0559ef"
import script from "./home-button.vue?vue&type=script&lang=js"
export * from "./home-button.vue?vue&type=script&lang=js"

import exportComponent from "/Users/qmaura/PANOPTIC/hkust-gz-vitals/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__